import { Button } from "@aix/ui"
import { Link, useRouter } from "@tanstack/react-router"
import { ArrowLeft, Home } from "lucide-react"

const NotFoundPage = () => {
  const router = useRouter()

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="text-center">
        <div className="relative mb-8">
          <span className="text-[12rem] font-bold leading-none text-muted-foreground/10 select-none sm:text-[16rem]">
            404
          </span>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="space-y-2 text-center">
              <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">Page not found</h1>
              <p className="text-lg text-muted-foreground">
                The page you&apos;re looking for doesn&apos;t exist or has been moved.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <Button variant="outline" onClick={() => router.history.back()} className="gap-2">
            <ArrowLeft className="h-4 w-4" />
            Go back
          </Button>
          <Link to="/home">
            <Button className="gap-2">
              <Home className="h-4 w-4" />
              Back to home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage
